import SCROLL from "./plugins/scroll";
import smoothscroll from 'smoothscroll-polyfill'
import 'jquery.easing';

// IE11でSVGの外部参照を有効にする
import 'svgxuse'

const [w, d, l, mq] = [window, document, location, window.matchMedia('(max-width: 900px)')];

const addClassBody = str => d.body.classList.add(str);
const addClassHTML = str => d.documentElement.classList.add(str);

const detailInit = id => {
  switch ( id ) {
    case 47: addClassBody('is-seven-reason'); break
    case 2: {
      addClassBody('is-kitchenReform');
      addClassHTML('is-kitchenReform');
      d.querySelector('.element_detail').classList.remove('element_detail');
      break
    }
  }

  $(() => {
    $('[data-load-html]').each( (i,v) => {
      $.get(`/src/html/${v.dataset.loadHtml}.html`).then((res) => $(v).replaceWith(res) );
    });

  });

  // ページトップリンクをスクロール量で表示するサンプル
  $.scrollspy({
    trigger:200,
    onBefore(/* pos */) {
      $('.kitchen-pagetop__wrap').addClass('hidden');
    },
    onAfter() {
      $('.kitchen-pagetop__wrap').removeClass('hidden');
    }
  })
}

if( l.pathname == '/reform/' && /article=/.test( l.search ) ) {

  SCROLL();
  
  const id = parseInt( l.search.replace(/^.+article=([\d]+)(.+)?$/,'$1') );

  d.addEventListener('DOMContentLoaded', () => detailInit(id) );

  // アンカーリンクスクロール設定
  $(d).on('click','a[href^="#"],a[href*="#"]',function(e){
    
    if( !mq.matches ) return true;

    var path = $(this).attr('href').match(/^([^#]+)(#.*)?/)||[];
    if( path[1] === location.pathname + location.search ){
      e.preventDefault();
      $(this).attr('href',path[2]);
    }else if( path[1] != undefined ){
      return true
    }
    var speed =   500,
        href =    $(this).attr('href'),
        $target = $(href == '#pagetop' || href == '#top' ? 'html' : href ),
        pos =     $target.offset().top;
        if( mq.matches ){
          var headerHeight = $('.sitetitleLogo').height();
          pos = (pos - headerHeight);
        }
    $('body,html').animate({scrollTop:pos},speed,'easeInOutExpo');
    if(href!='#pagetop' && href!='#top')
      window.history.pushState(null, null, this.hash);
    return false;
  });

}


// スクロール監視
$.scrollspy = function(option){
  var opt = $.extend(true, {
    interval: 300,
    trigger: 1000,
    duration: 5000,
    onBefore: function(){},
    onAfter: function(){}
  }, option),
  checkTimer,
  runTimer,
  is_run = false,
  pos = 0,
  checkPos = function(){
    pos = w.pageYOffset;
    if(pos < opt.trigger) opt.onBefore(pos);
    if(pos >= opt.trigger) opt.onAfter(pos);
    checkTimer = setTimeout(checkPos,opt.interval);
  },
  runCheck = function(){
    if(!is_run){
      checkPos();
      is_run = true;
      clearTimeout(runTimer);
      runTimer = setTimeout(function(){
        clearTimeout(checkTimer);
        is_run = false;
      },opt.duration);
    }
  };
  $(w).on('scroll',runCheck);
}